<template>
    <div>
        <div class="ix-comments-loader" v-if="loading">
            <i class="far fa-circle-notch fa-spin"></i> Chargement des sous-tâches
        </div>

        <div v-if="!loading">
            <div class="progress mb-2" style="height: 3px;" v-if="subtasks.length > 0">
                <div class="progress-bar" role="progressbar" v-bind:style="{'width': progress+'%'}" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100"></div>
            </div>

            <span class="d-block ix-text-secondary ix-text-small" v-if="subtasks.length == 0 && !editable">Il n'y a pas de sous-tâches renseignées</span>
        
            <div class="ix-table-box" v-if="subtasks.length > 0 || editable">
                <table class="ix-table ix-table-sm">
                    <draggable v-model="subtasks" tag="tbody" handle=".handle-line" @change="updateSubstasks()" v-if="subtasks.length > 0">
                        <tr v-for="(subtask, subtaskIndex) in subtasks">
                            <td class="text-center" style="width: 30px;" v-if="editable">
                                <span class="ix-drag-icon handle-line"></span>
                            </td>
                            <td>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" :id="'subtask' + subtaskIndex" v-model="subtask.is_done" @change="updateSubtaskChange(subtask)" :disabled="!workable">
                                    <label class="form-check-label" :for="'subtask' + subtaskIndex" v-bind:class="{'ix-text-crossed': subtask.is_done}">
                                        {{ subtask.designation }}
                                    </label>
                                </div>
                            </td>
                            <td style="width: 50px;" v-if="editable">
                                <button class="btn btn-sm transparent" type="button" @click="deleteSubtask(subtaskIndex)">
                                    <i class="far fa-trash"></i>
                                </button>
                            </td>
                        </tr>
                    </draggable>
                    <tr v-if="editable">
                        <td colspan="100%" style="padding: 10px;">
                            <div class="input-group">
                                <input type="text" class="form-control form-control-sm" id="newSubtaskInput" placeholder="Saisir une nouvelle sous-tâche" v-model="newSubtask" v-on:keyup.enter="addSubtask()" >
                                <div class="input-group-append">
                                    <button class="ix-btn ix-btn-icon blue" type="button" @click="addSubtask()" :disabled="!newSubtask || loadingForm">
                                        <span v-if="!loadingForm"><i class="far fa-plus"></i></span>
                                        <span v-if="loadingForm"><i class="far fa-circle-notch fa-spin"></i></span>
                                    </button>
                                </div>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import $ from "jquery";
    import draggable from 'vuedraggable';

    export default {
        name: "SubtasksManager",
        props : {
            taskId : Number,
            admin : Number,
            workable: Boolean,
            editable: Boolean,
            url : "",
            stateSubtaskUrl : ""
        },
        components : {
            draggable
        },
        watch: {
            taskId: async function () {
                if (this.taskId) {
                    await this.getData();
                }
            },
        },
        computed: {
            progress: function() {
                if (this.subtasks.length > 0) {
                    var total = this.subtasks.length
                    var done = this.subtasks.filter(subtask => { return subtask.is_done }).length

                    return Math.round((done / total) * 100)
                }

                return 0
            },
        },
        data() {
            return {
                subtasks : [],

                editMode: false,
                loading: true,
                loadingForm: false,
            
                newSubtask : null,
                is_admin : this.admin || false,
            }
        },
        methods : {
            async deleteSubtask(index) {
                this.subtasks.splice(index, 1)
                await this.updateSubstasks()
            },
            async addSubtask() {
                if (this.editable && this.newSubtask && !this.loadingForm) {
                    this.subtasks.push({designation: this.newSubtask, is_done: 0})
                    await this.updateSubstasks()

                    this.newSubtask = ""
                    $('#newSubtaskInput').focus()
                }
            },
            async updateSubstasks(){
                this.loadingForm = true
                fetch(this.url.replace('##', this.taskId), {
                    ...{
                        method: 'PUT'
                    },
                    ...this.getHttpJsonRequestHeaders(),
                    ...{
                        body :  JSON.stringify({
                            subtasks : this.subtasks,
                        })
                    },
                }).then((response) => {
                    this.loadingForm = false;
                    if (response.status == 200) {
                        response.json().then((data) => {
                            this.subtasks = data
                        })
                    }
                }).catch(error => {
                    this.loadingForm = false;
                    console.log(error)
                });
            },
            async updateSubtaskChange(subtask){
                fetch(this.stateSubtaskUrl.replace('##', subtask.id) , {
                    ...{
                        method: 'PUT'
                    },
                    ...{
                        body :  JSON.stringify({
                            done : subtask.is_done,
                        })
                    },
                    ...this.getHttpJsonRequestHeaders()
                }).then((response) => {
                    if (response.status != 200) {
                        subtask.is_done = !subtask.is_done
                    }
                }).catch(error => {
                    subtask.is_done = !subtask.is_done
                    console.log(error)
                });
            },
            async getData(){
                this.loading = true;

                fetch(this.url.replace('##', this.taskId) , {
                    ...{
                        method: 'GET'
                    },
                    ...this.getHttpJsonRequestHeaders()
                }).then((response) => {
                    this.loading = false;
                    if (response.status == 200) {
                        response.json().then((data) => {
                            this.subtasks = data
                        })
                    }
                }).catch(error => {
                    this.loading = false;
                    console.log(error)
                });
            },
        },

        async mounted(){
            if (this.taskId) {
                await this.getData()
            }
        }
    }
</script>
